( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {

        var loadingText = document.documentElement.lang === 'fr' ? 'Chargement...' : 'Loading...';

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function loadMorePosts() {

            $( '.js--post-feed-container' ).on( 'click', '.js--load-more-posts', function( event ) {
                event.preventDefault();

                // Grey out button
                $( this )
                    .css( {
                        'opacity': '0.6',
                        'pointer-events': 'none',
                        'text-decoration': 'none',
                    } )
                    .text( loadingText );

                // Grab URL of next page
                var nextPageURL = $( this ).attr( 'href' );

                // Grab content of next page using .get()
                $.get( nextPageURL, function( data, status ) {

                    // Remove existing 'Load More' button
                    $( '.js--load-more-posts' ).parent().remove();

                    // Get the posts from response data
                    var nextPageHTML = $( $.parseHTML( data ) );
                    var nextPosts = nextPageHTML.find( '.js--post-feed-container' );

                    // Attach them to our existing posts container
                    $( '.js--post-feed-container' ).append( nextPosts.html() );
                } );
            } );

        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        loadMorePosts();

        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                loadMorePosts();
            } );
        }

    } );

} )( window, document, jQuery );
